import { Component, OnInit } from '@angular/core';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";
import {TranslationFileTypes} from "../../../models/translation.constants";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import {TranslationModel} from "../../../models/translation.model";

@Component({
    standalone: false,
    selector: 'particle-translation-download-dialog',
  templateUrl: './translation-download-dialog.component.html',
  styleUrls: ['./translation-download-dialog.component.scss']
})
export class TranslationDownloadDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  translationModel: TranslationModel = new TranslationModel();
  constructor(private dialogRef: MatDialogRef<TranslationDownloadDialogComponent>, protected dialog: MatDialog) {
  }

  ngOnInit() {
    this.translationModel = this.data.input.translationModel;
  }

  onOkClicked(): boolean {
    return true;
  }

  onDownload(fileType: string) {
    this.dialogRef.close({action: 'OK', fileType: fileType});
  }
}
